import { createContext, useContext } from 'react';
import { usePlanningStore } from '@/stores/planning';
import { PLANNING_ZOOM_LEVELS } from '@/utils/planningZoom';

/** Zoom factor the board is rendered at. Cards need it to undo the scaling of
 *  their drag transform; only the full planning board sets it (modal stays 1). */
export const PlanningZoomContext = createContext(1);
export const usePlanningZoom = () => useContext(PlanningZoomContext);

const btnCls = 'p-1.5 text-td-navy hover:bg-gray-50 transition-colors disabled:opacity-40 disabled:cursor-not-allowed';

/** − 100% + control in the planning header. Clicking the percentage resets. */
export function ZoomControl() {
  const zoom = usePlanningStore((s) => s.zoom);
  const zoomIn = usePlanningStore((s) => s.zoomIn);
  const zoomOut = usePlanningStore((s) => s.zoomOut);
  const setZoom = usePlanningStore((s) => s.setZoom);

  return (
    <div className="flex items-center rounded-lg border border-gray-300 overflow-hidden">
      <button type="button" onClick={zoomOut} disabled={zoom <= PLANNING_ZOOM_LEVELS[0]} className={btnCls} aria-label="Uitzoomen" title="Uitzoomen">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
        </svg>
      </button>
      <button
        type="button"
        onClick={() => setZoom(1)}
        className="px-1.5 py-1 min-w-[3rem] text-xs font-semibold text-td-navy border-x border-gray-300 hover:bg-gray-50 transition-colors"
        aria-label="Zoom herstellen"
        title="Zoom herstellen"
      >
        {Math.round(zoom * 100)}%
      </button>
      <button type="button" onClick={zoomIn} disabled={zoom >= PLANNING_ZOOM_LEVELS[PLANNING_ZOOM_LEVELS.length - 1]} className={btnCls} aria-label="Inzoomen" title="Inzoomen">
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
      </button>
    </div>
  );
}
